/**
 * FaceOverlay Component
 *
 * Renders the face overlay on top of a body image.
 * Handles special effects and animations.
 */
import React from "react";

const FaceOverlay = ({ style, isSpecialEffect }) => {
  return (
    <div
      className={`face-overlay ${isSpecialEffect ? "special-effect" : ""}`}
      style={style}
    />
  );
};

export default FaceOverlay;
